import type { ReactNode } from "react";

interface SectionLabelProps {
  children: ReactNode;
  tone?: "light" | "dark";
  className?: string;
}

export default function SectionLabel({ children, tone = "light", className = "" }: SectionLabelProps) {
  const isDark = tone === "dark";

  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <span className={`h-px w-8 shrink-0 ${isDark ? "bg-accent-400/70" : "bg-accent-500"}`} />
      <span
        className={`ocean-label text-[10px] md:text-[11px] ${
          isDark ? "text-accent-300/90" : "text-accent-600"
        }`}
      >
        {children}
      </span>
    </span>
  );
}